module.exports = __webpack_public_path__ + "img/logo_news_forbes@4x.2944f87e.png";